<template>
  
  <v-form>
    
    <div class="container">
      <div class="panel panel-sm">
        <div class="panel-heading form-group d-flex justify-content-center align-items-center"> 
            <h4 class="p-4">Import d'un fichier .csv</h4>
            <a 
              href="/media/exemple/exemple.csv" 
              download="exemple.csv" 
              class="btn btn-link"
            >
              Télécharger un fichier .csv exemple
            </a>
        </div>
        <div class="panel-body">
          <div class="form-group d-flex justify-content-center align-items-center">
            <label for="csv_file" class="control-label col-sm-3 m-0">Fichier .csv à importer</label>
            <div class="col-sm-9">
                <input type="file" id="csv_file" name="csv_file" class="form-control_1" @change="loadCSV($event)">
            </div>
          </div>
          <!-- <div class="col-sm-offset-3 col-sm-9">
          <div class="checkbox-inline pr-2">
              <label for="header_rows"><input type="checkbox" id="header_rows">Votre fichier contient-il un en-tête</label>
          </div>
          </div> -->
          
          <!-- <div class="col-sm-offset-3 col-sm-9">
          <a href="#" class="btn btn-primary">Parcourir le fichier .csv</a>
          </div> -->
          <div style="display: grid; grid-template-columns: repeat(2,50%)">
            <v-btn color="primary" class="m-4 float-right" @click="submit">
              Ajouter à la liste des utilisateurs
            </v-btn>
            <v-btn color="primary" class="m-4 float-right" @click="() => {compteActive = true; submit()}">
              Ajouter les utilisateurs et activer les comptes
            </v-btn>
          </div>
          <table v-if="csvUsers && csvUsers[0]">
            <thead>
                <tr>
                  <th v-for="item in Object.keys(csvUsers[0]).filter(colName => colName !== 'ClientId' && colName !== 'DroitId')" :key="item.id">
                      {{ item }}
                  </th>
                </tr>
            </thead> 
            <tr v-for="csv in csvUsers" :key="csv.id">
                <td v-for="item in Object.keys(csvUsers[0]).filter(colName => colName !== 'ClientId' && colName !== 'DroitId')" :key="item.id">
                  {{csv[item]}}
                </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </v-form>
</template>

<script>

import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import csv from "csvtojson";

export default {
  name: "uploadFiles2",
  data:() => ({
    csvUsers: [],
    loading: false,
    compteActive: false,
  }),
  methods: {
    loadCSV(e) {
      const file = e.target.files[0];
      const extension = file.name.split('.').pop().toLowerCase();
      if (extension !== 'csv') {
        Swal.fire({
          title: "Fichier invalide",
          text: "Le fichier sélectionné n'est pas un CSV. Veuillez choisir un fichier .csv.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
        e.target.value = "";
        this.csvUsers = [];
        return;
      }

      if (window.FileReader) {
        var reader = new FileReader();
        reader.readAsText(e.target.files[0], 'UTF-8');
        // Handle errors load
        reader.onload = event => {
          csv({
              delimiter: 'auto',
              ignoreEmpty: true
            })
            .fromString(event.target.result)
            .then(result => {

              if (!result || result.length == 0) {
                Swal.fire({
                  title: "Fichier vide ou invalide",
                  text: "Le fichier ne contient aucune donnée exploitable.",
                  icon: "warning",
                  confirmButtonClass: "btn btn-secondary",
                });
                e.target.value = "";
                this.csvUsers = [];
                return;
              }

              this.csvUsers = [];
              for (let i = 0; i < result.length; i++) {
                const element = result[i];
                Api.query('clients', {params: {name: element.Client}})
                .then(response => {
                  const client = response.data['hydra:member'][0];
                  console.log(response)
                  if (client) {
                    element.Client = client.name;
                    element.ClientId = client['@id'];
                  } else {
                    element.Client = null;
                  }
                })
              
                Api.query("user_rights", { params: { name: element.Droit } })
                .then(response => {
                  const rights = response.data['hydra:member'][0];
                  if (rights) {
                    element.Droit = rights.name;
                    element.DroitId = rights['@id'];
                  } else {
                    element.DroitId = null;
                  }
                  this.csvUsers.push(element);
                })
              }
            })
            .catch(error => console.log(error))
          ;
        };
        reader.onerror = function(evt) {
          if(evt.target.error.name == "NotReadableError") {
            alert("Cannot read file !");
          }
        };
      } else {
        alert('FileReader are not supported in this browser.');
      }
    },

    // add csv users
    submit: async function() {
      this.loading = true;
      const failedUsers = [];

      if (!this.csvUsers || this.csvUsers.length == 0) {
        Swal.fire({
          title: "Aucun fichier sélectionné",
          text: "Veuillez sélectionner un fichier CSV valide avant d'ajouter les utilisateurs.",
          icon: "warning",
          confirmButtonClass: "btn btn-secondary",
        });
        return;
      }

      for(var i = 0; i < this.csvUsers.length; i++){
        try{
          const response = await Api.post("users", {
            firstname: this.csvUsers[i].Firstname,
            lastname: this.csvUsers[i].Lastname,
            email: this.csvUsers[i].Email,
            password: '',
            client: this.csvUsers[i].ClientId,
            userRight: this.csvUsers[i].DroitId,
            roles: this.csvUsers[i].Roles,
          });
          if(this.compteActive){
            if (response && response.data && response.data.id) {
              Api.patch('users', `${response.data.id}/send-password`, {id: response.data.id});
            }
          }
          this.$emit("addCsvUser", response.data);
        } catch (error) {
          failedUsers.push(this.csvUsers[i]);
        }
      }

      if (failedUsers.length == 0) {
        Swal.fire({
          title: "",
          text: "Tous les utilisateurs ont été créés avec succès.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
        });
      } else {
        //Dans le cas où la requête a échoué.
        Swal.fire({
          title: "Erreur",
          text: `${failedUsers.length} utilisateur(s) n'ont pas pu être créés.`,
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
        });
      }
      this.csvUsers = [];
      this.loading = false;
      this.compteActive = false;
    },
  }
}
</script>

<style lang="scss" scoped>
    .panel {
    border: 1px solid #dfdfdf;
    box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0 0;
    margin: 10px;
    } 
    .panel.panel-sm {
    max-width: 700px;
    margin: 10px auto;
    }
    .panel-heading {
    border-bottom: 2px solid #dfdfdf;
    }
    .panel-heading h1, .panel-heading h2, .panel-heading h3, .panel-heading h4, .panel-heading h5, .panel-heading h6 {
    margin: 0;
    padding: 0;
    }
    .panel-body .checkbox-inline {
    padding: 15px 20px;
    }
    table{
      font-family: arial, sans-serif;
      border-collapse: collapse;
      width: 100%;
    }
    td, th {
      border: 1px solid #dddddd;
      text-align: left;
      padding: 8px;
    }
    tr:nth-child(even){
      background-color: #dddddd;
    }
    .form-control_1 {
      display: block;
      width: 100%;
      height: calc(1.5em + 1.3rem + 2px);
      padding: 0.65rem 1rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #3F4254;
      background-color: #ffffff;
      background-clip: padding-box;
      //border: 1px solid #E4E6EF;
      //border-radius: 0.42rem;
      -webkit-box-shadow: none;
      box-shadow: none;
      -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    }

</style>
